import React from 'react';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import { useAppContext } from '../../context/AppContext';
import './Layout.css';

const Layout = ({ children }) => {
  const { sidebarCollapsed, notification } = useAppContext();

  return (
    <div className="layout">
      <Sidebar />
      <div
        className={`layout__main ${sidebarCollapsed ? 'layout__main--collapsed' : ''}`}
      >
        <Navbar />
        <main className="layout__content">
          <div className="layout__content-inner animate-fade-in">{children}</div>
        </main>
      </div>

      {/* Global Notification Toast */}
      {notification && (
        <div className={`layout__toast layout__toast--${notification.type}`}>
          <span>{notification.message}</span>
        </div>
      )}
    </div>
  );
};

export default Layout;
